// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tags-list{display:inline;position:relative;line-height:150%}.tags-list__tag,.tags-list__tag tag{line-height:150%;animation-duration:300ms;margin:2px 0}.tags-list__cover{display:flex;justify-content:center;align-items:center}.tags-list__tag-active{position:relative;z-index:1}", ""]);
// Exports
module.exports = exports;
